import { useState } from "react";
import "./footer.css";
import logo from "../assets/logo.webp";

export default function Footer() {
  const [logoSrc, setLogoSrc] = useState(logo);
  const fallbackLogo = `${process.env.PUBLIC_URL}/logo192.png`;
  const handleLogoError = () => {
    if (logoSrc !== fallbackLogo) {
      setLogoSrc(fallbackLogo);
    }
  };
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <img
          src={logoSrc}
          alt="YShaleh"
          className="footer-logo"
          width="120"
          height="120"
          loading="lazy"
          decoding="async"
          onError={handleLogoError}
        />

        <div className="footer-social">
          <details className="social-dropdown">
            <summary className="social-btn" aria-label="Instagram">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zm10 2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm-5 3.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 0 1 12 8.5zm0 2A2.5 2.5 0 1 0 14.5 13 2.5 2.5 0 0 0 12 10.5zM17.5 6.7a1.1 1.1 0 1 1-1.1 1.1 1.1 1.1 0 0 1 1.1-1.1z" />
              </svg>
            </summary>
            <div className="social-menu">
              <a
                href="https://www.instagram.com/y.shaleh90"
                target="_blank"
                rel="noopener noreferrer"
              >
               y.shaleh90
              </a>
              <a
                href="https://www.instagram.com/y.shaleh2"
                target="_blank"
                rel="noopener noreferrer"
              >
               y.shaleh2
              </a>
            </div>
          </details>

          <a
            href="https://www.snapchat.com/add/y.shaleh90"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Snapchat"
            className="social-btn"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2c3.3 0 5.2 2.7 5.2 5.3v3.4c0 .6.3 1 .9 1.2l1.6.6c.5.2.5.9 0 1.1l-1.9.7c-.5.2-.9.6-1 1.1-.3 1.7-1.6 3.1-3.6 3.1h-2.4c-2 0-3.3-1.4-3.6-3.1-.1-.5-.5-.9-1-1.1l-1.9-.7c-.5-.2-.5-.9 0-1.1l1.6-.6c.6-.2.9-.6.9-1.2V7.3C6.8 4.7 8.7 2 12 2z" />
            </svg>
          </a>
        </div>

        <div className="footer-copy">All right recervied - yshaleh - 2026</div>
      </div>
    </footer>
  );
}
